
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/model-sandbox",
      function () {
        return require("private-next-pages/model-sandbox/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/model-sandbox"])
      });
    }
  